var ModalWarningLmc = {
  view: function (ctrl, args) {

    return m('div.dm-overlay',
      m("div.dm-table", [
        m("div.dm-cell", [
          m("div.dm-modal", [
            m(".bg-primary[style='padding:10px;z-index:1;']", [
              m("span[id='modalTitleLmc'][style='margin-right: 15px']", "Предупреждение"),
              m("span.pull-right[style='cursor: pointer;']", {
                onclick: ModalContainerWarningLmc.close
              }, [
                m("i.glyphicon.glyphicon-remove"),
                m.trust('&nbsp;Закрыть')
              ])
            ]),
            [
              m("div", [
                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                  m("div[style='']", [
                    m("div[id='modalContentLmc'][style='text-align: center']", "Превышен максимальный вес LMC"),
                    m(".row[style='text-align: center; margin-top: 15px']", [
                      m("button.btn.btn-warning.btn-lg", {
                        //id: "",
                        onclick: function () {
                          ModalContainerWarningLmc.close();
                        }
                      }, "Ок")
                    ]),
                  ]),
                ])
              ])
            ]
          ])
        ])
      ])
    );
  }
};

export var ModalContainerWarningLmc = {
  container: null,
  idElement: null,
  init: function () {
    ModalContainerWarningLmc.container = document.querySelector('#modalWarningLmc');
    if (!ModalContainerWarningLmc.container) {
      ModalContainerWarningLmc.container = document.createElement('div');
      ModalContainerWarningLmc.container.id = 'modalWarningLmc';
      ModalContainerWarningLmc.container.hidden = true;
      document.body.appendChild(ModalContainerWarningLmc.container);
      m.mount(ModalContainerWarningLmc.container, m.component(ModalWarningLmc, {data:  "", type: false, idElement: ""}));
    }
  },
  open: function (title, message, buttons= null, idElement = null) {
    ModalContainerWarningLmc.container = document.querySelector('#modalWarningLmc');
    if(typeof(idElement) != "undefined" && idElement !== null)
      ModalContainerWarningLmc.idElement = idElement;
    if(typeof(removeAll) != "undefined" && removeAll !== null)
      ModalContainerWarningLmc.removeAll = removeAll;
    if (ModalContainerWarningLmc.container) {
      // if(title){
        // document.getElementById("modalTitleLmc").innerHTML = title;
      // }
      // if(message){
        // document.getElementById("modalContentLmc").innerHTML = message;
      // }
      /*if(buttons){
          document.getElementById("modalButtons").innerHTML = "";
          document.getElementById("modalButtons").append(buttons);
      }*/


      ModalContainerWarningLmc.container.hidden = false;
    }
  },
  close: function () {
    ModalContainerWarningLmc.container.hidden = true;
  }
};
